// extracted by mini-css-extract-plugin
export default {"base":"Tag_base__zOaTO","L5":"Tag_L5__2D1YG","L4":"Tag_L4__P4-dX","L3":"Tag_L3__DxhBH","L2":"Tag_L2__66FDi","L1":"Tag_L1__ezQv-"};